import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-issue-return',
  templateUrl: './issue-return.component.html',
  styleUrls: ['./issue-return.component.scss']
})
export class IssueReturnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
